module.exports = __webpack_public_path__ + "img/30.1ce8a2f1.jpg";